import React, { FC, useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { useStores } from 'stores/hooks/hooks';
import Grid from 'components/UI/Grid';
import Splitter from 'components/shared/Splitter';
import Plots from './Plots';
import PlotSensors from './PlotSensors';

const Container = styled.div`
  height: 100%;
  width: 100%;
  justify-content: flex-start;
  overflow-y: auto;
`;

const ResellerPlots: FC = observer(() => {
  const {
    resellersStore: { selectedRowsPlots },
    plotsStore,
  } = useStores();

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    plotsStore.getPlotProfile().then(() => {
      setIsLoading(false);
    });
  }, [plotsStore]);

  return (
    <Container>
      {!selectedRowsPlots?.length && <Plots isLoading={isLoading} />}
      {!!selectedRowsPlots?.length && (
        <Splitter>
          <div style={{ height: '100%' }}>
            <Plots isLoading={isLoading} />
          </div>
          <PlotSensors />
        </Splitter>
      )}
    </Container>
  );
});

export default ResellerPlots;
